<template>
  <div v-if="isEmpty || isLoading" class="no-contents-wrapper">
    <FerryIcon :size="isMobileSize ? 50 : 100" />

    <div v-if="isLoading" class="loading-text-wrapper">
      <div class="spinner"></div>
      <p>{{ loadingText }}</p>
    </div>
    <p v-else>{{ contentText ? contentText : loadingText }}</p>
  </div>
</template>

<script>
import FerryIcon from 'vue-material-design-icons/Ferry';

export default {
  name: 'NoContent',
  components: { FerryIcon },
  props: {
    isEmpty: Boolean,
    isLoading: Boolean,
    contentText: String,
  },
  computed: {
    isMobileSize() {
      return window.innerWidth < 768;
    },
    loadingText() {
      return this.isLoading ? this.$t('messages.loading') : this.$t('messages.preparating');
    },
  },
};
</script>

<style scoped>
.no-contents-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  min-height: 500px;
  margin-bottom: 24px;
  color: var(--Grey-grey-500);
  background: var(--Grey-grey-50);
  gap: 20px;
}

@media screen and (min-width: 768px) {
  .no-contents-wrapper {
    margin-bottom: 60px;
  }
}

.loading-text-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
}

/* 스피너 */
.spinner {
  width: 20px;
  height: 20px;
  border: 3px solid var(--Grey-grey-200);
  border-top: 3px solid var(--Grey-grey-500);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

/* 스피너 애니메이션 */
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
